import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

import { trackSignedInOncePerSession } from './events';
import { identifyUser } from './posthog';

// Ties PostHog events to the logged-in person. Renders nothing — it just
// fires `identify` once Auth0 reports an authenticated user. The Auth0
// `sub` is the canonical `distinct_id` (matches the server-side
// distinct_id) so client + server events stitch into one person. Reset
// on logout is handled in `useLogout`. `identifyUser` is a no-op when
// PostHog is unconfigured, so this is safe to mount unconditionally.
export function PostHogIdentify() {
  const { isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user?.sub) {
      identifyUser(user.sub, { email: user.email, name: user.name });
      // Once-per-tab-session (sessionStorage marker keyed on `sub`), so the
      // re-mount on every authenticated full page load doesn't re-emit it.
      trackSignedInOncePerSession(user.sub);
    }
    // Keyed on the stable Auth0 `sub` only. `useAuth0()` hands back a fresh
    // `user` object whenever its reducer re-runs (token refresh, silent
    // re-auth), so depending on `user.email`/`user.name` would re-fire
    // identify on that churn for no benefit. email/name are captured at
    // first identification, which is what we want.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.sub]);

  return null;
}
